__turbopack_context__.v({
  "color_divider": "_1ULowq_color_divider",
  "container1": "_1ULowq_container1",
  "list_decs": "_1ULowq_list_decs",
  "mobile_head": "_1ULowq_mobile_head",
  "right_info": "_1ULowq_right_info",
  "title_head": "_1ULowq_title_head",
  "title_head2": "_1ULowq_title_head2",
  "wrapper": "_1ULowq_wrapper",
});
